import ToastHighLighter from '@/lib/ToastHighLighter';

export const CheckboxRadioCode = () => {
  const language = 'html';
  const codeString = `
  // Checkboxes and radios
  <div class="my-3">
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="exampleRadios"
        id="exampleRadios1"
        value="option1"
        checked
        onChange={e => {}}
      />
      <label class="form-check-label" htmlFor="exampleRadios1">
        Default radio
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="exampleRadios"
        id="exampleRadios2"
        value="option2"
      />
      <label class="form-check-label" htmlFor="exampleRadios2">
        Second default radio
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="exampleRadios"
        id="exampleRadios3"
        value="option3"
        disabled
      />
      <label class="form-check-label" htmlFor="exampleRadios3">
        Disabled radio
      </label>
    </div>
  </div>

  <div class="my-3">
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        id="flexSwitchCheckDefault"
      />
      <label class="form-check-label" htmlFor="flexSwitchCheckDefault">
        Default switch checkbox input
      </label>
    </div>
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        id="flexSwitchCheckChecked1"
        checked
        onChange={e => {}}
      />
      <label class="form-check-label" htmlFor="flexSwitchCheckChecked1">
        Checked switch checkbox input
      </label>
    </div>
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        id="flexSwitchCheckDisabled2"
        disabled
      />
      <label
        class="form-check-label"
        htmlFor="flexSwitchCheckDisabled2"
      >
        Disabled switch checkbox input
      </label>
    </div>
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        id="flexSwitchCheckCheckedDisabled3"
        checked
        disabled
        onChange={e => {}}
      />
      <label
        class="form-check-label"
        htmlFor="flexSwitchCheckCheckedDisabled3"
      >
        Disabled checked switch checkbox input
      </label>
    </div>
  </div>

  <div class="mb-3 form-check">
    <input
      type="checkbox"
      class="form-check-input"
      id="exampleCheck1"
    />
    <label class="form-check-label" htmlFor="exampleCheck1">
      Check me out
    </label>
  </div>
`;

  return (
    <>
      <ToastHighLighter
        name={'formfloating'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
